import React from 'react';
import styled from 'styled-components';
import { config } from '@keytrade/functions';

import useTranslations from '@/hooks/useTranslations';

const { list: colors } = config.colors;

type Props = {
  isEnabled: boolean;
};

export const Span = styled.span`
  float: left;
  margin-right: 1.2rem;
  color: ${colors.BlueDawn};
  font-size: 1.4rem;
  font-weight: 700;
  padding: 0 6px;
  border: 2px solid ${colors.BlueDawn};
  border-radius: 6px;
  height: fit-content;
`;

const NewBadge: React.FC<Props> = (props) => {
  const { isEnabled } = props;

  const { t } = useTranslations();

  if (!isEnabled) {
    return null;
  }

  return <Span>{t('new')}</Span>;
};

export default NewBadge;
